'use client';

import { FormControl, FormLabel, TextField } from '@mui/material';

import { inputSx } from './fieldStyles';

// A 6-digit one-time-code input, shared by the MFA verify and MFA setup steps.
export const VerificationCodeField = ({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
}) => (
  <FormControl size='small' className='w-full'>
    <FormLabel htmlFor={id}>Verification code</FormLabel>
    <TextField
      autoFocus
      value={value}
      onChange={(e) => onChange(e.target.value.trim())}
      sx={inputSx}
      slotProps={{
        htmlInput: {
          id,
          'data-testid': id,
          inputMode: 'numeric',
          autoComplete: 'one-time-code',
          maxLength: 6,
        },
      }}
    />
  </FormControl>
);
